// extracted by mini-css-extract-plugin
export default {"Comment":"styles_Comment__VdWlq","Comment__box":"styles_Comment__box__iVfbG","Comment__boxGreen":"styles_Comment__boxGreen__9XizU","Comment__text":"styles_Comment__text__2n5Hf"};